"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Interval2 = _interopRequireDefault(require("./Interval"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var FrameRange = /*#__PURE__*/function (_Interval) {
  (0, _inherits2["default"])(FrameRange, _Interval);

  var _super = _createSuper(FrameRange);

  function FrameRange() {
    (0, _classCallCheck2["default"])(this, FrameRange);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(FrameRange, [{
    key: "containsFrameNumber",
    value: function containsFrameNumber(frameNumber) {
      return (0, _get2["default"])((0, _getPrototypeOf2["default"])(FrameRange.prototype), "containsNumber", this).call(this, frameNumber);
    }
  }, {
    key: "copy",
    value: function copy() {
      return new FrameRange(this.start, this.end);
    }
  }], [{
    key: "isFrameRange",
    value: function isFrameRange(frameRange) {
      return frameRange instanceof FrameRange;
    }
  }, {
    key: "intersection",
    value: function intersection(frameRange1, frameRange2) {
      var interval = _Interval2["default"].intersection(frameRange1, frameRange2);

      if ((0, _isNil["default"])(interval)) return null;
      return new FrameRange(interval.start, interval.end);
    }
  }]);
  return FrameRange;
}(_Interval2["default"]);

exports["default"] = FrameRange;